// extracted by mini-css-extract-plugin
export default {"container":"style_container__RWQi3","heading":"style_heading__S6LRa","btnContainer":"style_btnContainer__b+GNd"};